// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"75":"9316a2d69ca912f3","888":"42afeb987a1ae4a0"}[chunkId] + ".css";
};